export const DOCUMENT_PAGE_WIDTH = 540
export const FIREFOX_TOOLBAR_HEIGHT = 33
export const PREVIEW_WIDTH_DEFAULT = 300
export const TEMP_DEFAULT_ROW_SIZE = 40
